import { Validator } from 'fluentvalidation-ts';
import { fieldRequiredValidationMessage } from '../../../../validators/sharedValidators';
import {
  beAnInteger,
  beGreaterThan,
  beLessThanOrEqualTo,
  beNumeric,
  beValidPercentage,
} from '../../../../validators/stringValidators';
import { BuildTypeCode } from '../../../projects/project';
import { FixingKitTypeCode } from '../../solar/fixingKitTypeCode';

export type SolarFormModel = {
  isExpanded: boolean;
  fixingKitTypeCode: FixingKitTypeCode;
  assumedDomesticHotWaterDemandInLitresPerDay: string;
  solarPanelQuantity: number | null;
  solarInputInKilowattHoursPerYear: string;
  solarFractionPercentage: string;
  includingHotWaterCylinder: boolean;
};

export const getInitialSolarFormModel = (buildTypeCode: BuildTypeCode, unitHasHeatPump: boolean): SolarFormModel => ({
  isExpanded: true,
  fixingKitTypeCode: buildTypeCode === 'NewBuild' ? 'InRoofSlate' : 'OnRoof',
  assumedDomesticHotWaterDemandInLitresPerDay: '',
  solarPanelQuantity: null,
  solarInputInKilowattHoursPerYear: '',
  solarFractionPercentage: '',
  includingHotWaterCylinder: !unitHasHeatPump,
});

export class SolarFormModelValidator extends Validator<SolarFormModel> {
  constructor(isDraft: boolean) {
    super();

    this.ruleFor('assumedDomesticHotWaterDemandInLitresPerDay')
      .must(beNumeric)
      .must(beAnInteger);

    this.ruleFor('assumedDomesticHotWaterDemandInLitresPerDay')
      .notEmpty()
      .withMessage(fieldRequiredValidationMessage)
      .must(beGreaterThan(0))
      .unless(() => isDraft);

    this.ruleFor('solarPanelQuantity')
      .notNull()
      .withMessage(fieldRequiredValidationMessage)
      .unless(() => isDraft);

    this.ruleFor('solarInputInKilowattHoursPerYear')
      .must(beNumeric)
      .must(beAnInteger);

    this.ruleFor('solarInputInKilowattHoursPerYear')
      .notEmpty()
      .withMessage(fieldRequiredValidationMessage)
      .must(beGreaterThan(0))
      .unless(() => isDraft);

    this.ruleFor('solarFractionPercentage')
      .must(beNumeric)
      .must(beAnInteger)
      .must(beValidPercentage);

    this.ruleFor('solarFractionPercentage')
      .notEmpty()
      .withMessage(fieldRequiredValidationMessage)
      .must(beGreaterThan(0))
      .must(beLessThanOrEqualTo(70))
      .unless(() => isDraft);
  }
}
